<!--
 * @Author:
 * @Description: 移交对象Form表单弹框
-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="title"
    width="1220px"
    v-if="dialogVisible"
    @close="closeDialog"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    custom-class="handover-form-dialog"
    v-dialogDrag
  >
    <el-form
      class="demo-form-inline"
      label-width="65px"
      :model="baseForm"
      :rules="baseFormRules"
      ref="baseForm"
    >
      <el-row :gutter="20" v-if="handoverFormProps.isShowClassType">
        <el-col :span="10">
          <el-form-item :label="$t('Categories')" prop="classId">
            <el-select
              class="w-full"
              v-model="baseForm.className"
              :placeholder="$t('pleaseSelect')"
              popper-class="select-tree"
              filterable
              clearable
              :disabled="!isEdit || attributeTableProps.type === 'upgrade'"
              ref="classSelectTree"
            >
              <el-option :label="baseForm.className" :value="baseForm.className" hidden></el-option>
              <el-tree
                ref="classTree"
                :data="classTreeList"
                :props="{
                  label: 'name',
                  children: 'children',
                }"
                node-key="id"
                :default-expanded-keys="defaultExpandedClassKey"
                :current-node-key="currentClassNodeKey"
                highlight-current
                @node-click="classNodeClick"
                @current-change="currentChange"
                :expand-on-click-node="true"
              ></el-tree>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-radio-group v-model="tabValue" @change="tabsChange">
        <el-radio-button v-for="item in tabsList" :key="item.label" :label="item.label">
          {{ item.name }}
        </el-radio-button>
      </el-radio-group>
      <div class="mt-20px" v-show="tabValue === '1'">
        <el-row :gutter="20" v-if="handoverFormProps.isShowClassType">
          <el-col :span="12">
            <el-form-item
              :label="$t('folder')"
              prop="pathName"
              v-if="handoverFormProps.tabs.length && handoverFormProps.tabs[0].name === '文档'"
            >
              <el-select
                v-model.trim="baseForm.pathName"
                :placeholder="`${$t('pleaseChoose')}`"
                class="w-full"
                popper-class="select-tree"
                ref="editSelectTree"
                @clear="clearHandle('edit')"
                :disabled="attributeTableProps.type === 'upgrade'"
              >
                <el-option :label="baseForm.pathName" :value="baseForm.pathName" hidden></el-option>
                <el-tree
                  :data="currentTree"
                  :props="{
                    label: 'name',
                    children: 'childrens',
                  }"
                  node-key="id"
                  :default-expanded-keys="defaultExpandedKey"
                  :current-node-key="currentNodeKey"
                  highlight-current
                  @node-click="editNodeClick"
                  :expand-on-click-node="false"
                  lazy
                  :load="lazyNode"
                ></el-tree>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <AttributeTable
          :attributeTableProps="attributeTableProps"
          @attributeValue="attributeValue"
          @primaryData="getPrimaryData"
          ref="attributeTable"
        />
      </div>
      <div class="mt-20px" v-show="tabValue === '2'">
        <AttributeTable
          :attributeTableProps="attributeTableProps"
          @classGroupValue="classGroupValue"
          @updateNullable="updateNullable"
          @extendTableValue="extendTableValue"
          ref="attributeTable"
        />
      </div>
      <!-- 对象的关联关系 -->
      <div class="mt-20px" v-if="tabValue === '3'">
        <AffiliationsTable :affiliationsTableProps="attributeTableProps" ref="affiliationsTable" />
      </div>
      <!-- 文档的关联关系 -->
      <div class="mt-20px" v-if="tabValue === '5'">
        <RelationShips :associatedDocumentsProps="attributeTableProps" ref="RelationShips" />
      </div>
      <!-- 关联文档 -->
      <div class="mt-20px" v-if="tabValue === '4'">
        <AssociatedDocuments
          :associatedDocumentsProps="attributeTableProps"
          ref="associatedDocuments"
        />
      </div>
      <!-- 扩展属性表 -->
      <div class="mt-20px" v-for="(item, index) in extendDataList" :key="index">
        <ExtendTable
          v-show="tabValue === item.label"
          :extendTableProps="item.extendTableProps"
          ref="extendTable"
        />
      </div>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
      v-if="isEdit || attributeTableProps.type === 'upgrade'"
    >
      <el-button @click="closeDialog">{{ $t('cancel') }}</el-button>
      <el-button
        v-if="isEdit || (this.isBeforeUpgrade && handoverFormProps.type === 'upgrade')"
        type="primary"
        :loading="saveLoading"
        @click="submit"
        >{{ $t('save') }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { getUrl } from '@/api/config'
import { getasync } from '@/api/article'
import stdClassListService from '@/services/stdClassListService'
import documentManagementService from '@/services/documentManagement'
import AttributeTable from './attributeTable'
import ExtendTable from './extendTable'
import AffiliationsTable from './affiliationsTable'
import AssociatedDocuments from './associatedDocuments'
import RelationShips from './relationships'

export default {
  name: 'handoverFormDialog',
  components: {
    AttributeTable,
    AffiliationsTable,
    AssociatedDocuments,
    RelationShips,
    ExtendTable,
  },
  props: {
    handoverFormProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      title: '',
      tabsList: [],
      tabValue: '1',
      saveLoading: false,
      baseForm: {
        classId: '',
        pathName: '',
        folderId: '',
        className: '',
      },
      baseFormRules: {
        classId: [{ required: true, message: this.$t('PleaseSelectACategory'), trigger: 'change' }],
        pathName: [{ required: true, message: this.$t('pleaseSelectFolder'), trigger: 'change' }],
      },
      listLoading: false,
      attributeList: [],
      classGroupList: [],
      attributeTableProps: {
        standardId: '',
        activeTab: '',
        classId: '',
        tabs: [],
        tableDetailData: null,
        isDataDetail: false,
        extendClassId: '',
      },
      extendTableProps: {
        attributeId: '',
        attributeData: '',
        data: '',
      },
      saveValue: {},
      classTreeList: [], // 实体树
      defaultExpandedClassKey: [], // 实体树默认展开节点
      currentClassNodeKey: '', // 实体树当前选中
      flattenedClassTreeList: [], // 拍平后的实体树
      currentTree: [], // 当前目录树数据
      defaultExpandedKey: [], // 文档路径默认展开节点
      currentNodeKey: '', // 文档路径树当前选中
      currentTreeList: [],
      isEdit: true,
      totalNullable: [], // 不嫩为空属性集合
      isBeforeUpgrade: false, // 是否是升版前
      extendDataList: [], // 扩展属性tab数据
      primaryValue: null, // 主键值
    }
  },
  watch: {
    handoverFormProps: {
      deep: true,
      immediate: true,
      async handler(val) {
        // console.log(val, 'vvv')
        if (val) {
          await this.getTypeList()
          this.dialogVisible = val.dialogVisible
          this.tabsList = _.cloneDeep(val.tabs)
          this.attributeTableProps = {
            standardId: val.standardId,
            activeTab: val.activeTab,
            classId: val.classId || '',
            tabs: val.tabs,
            tableDetailData: null,
            rowData: val.rowData,
            isDataDetail: val.isDataDetail ? val.isDataDetail : false,
            type: val.type,
          }
          if (val.tabs.length) {
            this.attributeTableProps.activeTab = val.tabs[0].label
            this.tabValue = val.tabs[0].label
          }
          if (val.tabs.length && val.tabs[0].name === '文档') {
            this.currentTree = await this.loadNode(true)
          }
          if (val.type === 'add') {
            this.title = this.$t('create')
            this.isEdit = true
            if (this.handoverFormProps.tabs[0].name === '文档' && this.handoverFormProps.folderId) {
              this.baseForm.folderId = this.handoverFormProps.folderId
              this.getPathName()
              this.defaultExpandedKey = [this.handoverFormProps.folderId]
              this.currentNodeKey = this.handoverFormProps.folderId
            }
          } else if (val.type === 'edit') {
            this.title = this.$t('edit')
            this.isEdit = true
          } else if (val.type === 'upgrade') {
            this.title = this.$t('documentUpscaling')
            this.isEdit = false
            this.baseFormRules.classId[0].required = false
            this.baseFormRules.pathName[0].required = false
            this.isBeforeUpgrade = true
          } else {
            this.title = this.$t('view')
            this.isEdit = false
          }
          // 编辑和查看
          if (val.rowData && val.rowData.id) {
            const classId = val.rowData.class_id || val.rowData.classId
            this.attributeTableProps.classId = classId
            this.baseForm.classId = classId
            this.defaultExpandedClassKey = [classId]
            await this.getDynamicTableDataDetail()
            if (val.rowData.folder_id) {
              this.baseForm.folderId = val.rowData.folder_id
              this.getPathName()
            }
            if (!this.handoverFormProps.isDataDetail) {
              this.classSelectChange(classId)
            }
          }
        }
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取路径名称
    getPathName() {
      const query = getUrl(this.baseForm.folderId)
      getasync(query).then((res) => {
        if (res.data && res.data.code === 0 && res.data.data) {
          this.baseForm.pathName = `${res.data.data.path}${res.data.data.name}/`
        }
      })
    },
    // 顶部页签切换
    tabsChange(e) {
      if (
        this.handoverFormProps.type === 'upgrade' &&
        ['4', '5'].includes(e) &&
        this.isBeforeUpgrade
      ) {
        this.$message.warning('请先升版保存后再操作')
        this.attributeTableProps.activeTab = '1'
        this.tabValue = '1'
        return
      }
      this.attributeTableProps.activeTab = e
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false
      this.$emit('handoverFormEmit', {
        dialogVisible: false,
      })
      this.tabsList = []
    },
    // 类别选择
    classSelectChange(selectId, type, data) {
      let currentClassList = null
      if (type === 'change') {
        this.attributeTableProps.classId = selectId
        currentClassList = data
      } else {
        currentClassList = _.find(this.flattenedClassTreeList, {
          id: selectId,
        })
        this.baseForm.className = currentClassList.name
        this.defaultExpandedClassKey = [selectId]
        this.currentClassNodeKey = selectId
        this.$nextTick(() => {
          this.$refs.classTree.setCurrentKey(selectId)
        })
      }
      this.tabsList = this.tabsList.filter((item) => {
        return item.label !== '2'
      })
      if (currentClassList) {
        this.tabsList.splice(1, 0, {
          name: currentClassList.name,
          label: '2',
        })
      }
    },
    // 获取对象类别列表
    async getTypeList() {
      if (this.handoverFormProps.tabs.length === 0) return
      const parameter = {
        standard_id: this.handoverFormProps.standardId,
        data_type: 1,
        approve_status: 1,
        info_type: null,
        catecode: null,
      }
      if (this.handoverFormProps.tabs[0].name === '位号') {
        parameter.info_type = 0
        parameter.catecode = 'tag'
      } else if (this.handoverFormProps.tabs[0].name === '文档') {
        parameter.info_type = '1'
        parameter.catecode = 'document'
      } else {
        parameter.info_type = null
        parameter.catecode = null
      }
      const reqData = {
        standardId: this.handoverFormProps.standardId,
        catecode: parameter.catecode,
        isLevel: false,
      }
      const res = await stdClassListService.getClassListTree(reqData)
      if (res.code === 0 && res.data) {
        this.classTreeList = res.data
        console.log(this.classTreeList, 'class=')
        // 将树形数据拍平并存储
        this.flattenedClassTreeList = this.flattenTreeData(this.classTreeList)
        console.log(this.flattenedClassTreeList, 'flattenedClassTreeList=')
      }
    },
    // 获取返回的数据
    attributeValue(val) {
      _.assign(this.saveValue, val.attributeValue)
      this.attributeList = val.attributeList
    },
    classGroupValue(val) {
      _.assign(this.saveValue, val.classGroupValue)
      this.classGroupList = val.classGroupList
    },
    updateNullable(val) {
      this.totalNullable = val
    },
    // 保存
    async submit() {
      if (this.handoverFormProps.isShowClassType && !this.baseForm.classId) {
        this.$message.warning('请选择类别！')
        return
      }
      if (
        this.handoverFormProps.isShowClassType &&
        this.handoverFormProps.tabs[0].name === '文档' &&
        !this.baseForm.pathName
      ) {
        this.$message.warning('请选择文件夹！')
        return
      }
      let flag = true
      this.totalNullable = [...new Set([...this.totalNullable])]
      if (this.totalNullable.length && _.isEmpty(this.saveValue)) {
        this.$message({
          message: `请先选择或输入${this.totalNullable[0].split('.')[1]}`,
          type: 'warning',
        })
        flag = false
        return
      }
      _.map(this.totalNullable, (item) => {
        const saveList = Object.keys(this.saveValue)
        const one = _.indexOf(saveList, item)
        if (
          one === -1 ||
          (one > -1 && (this.saveValue[item] === '' || this.saveValue[item] === null))
        ) {
          let tips = item.split('.')[1]
          if (_.indexOf(tips, '_') > -1) {
            tips = tips.split('_')[1]
          }
          this.$message({
            message: `请先选择或输入${tips}`,
            type: 'warning',
          })
          flag = false
        }
      })
      if (!flag) return
      // valueType = 7为枚举-多选，值用逗号分隔
      Object.keys(this.saveValue).forEach((key) => {
        if (this.saveValue[key] && Array.isArray(this.saveValue[key])) {
          this.saveValue[key] = this.saveValue[key].join(',')
        }
      })
      const params = {
        standardId: this.handoverFormProps.standardId,
        // dataId: this.handoverFormProps.rowData?.id,
        dataId: this.attributeTableProps.rowData?.id,
        classId: this.baseForm.classId || this.handoverFormProps.classId,
        folderId: this.baseForm.folderId,
        value: this.saveValue,
      }
      this.saveLoading = true
      let res = null
      if (this.handoverFormProps.type === 'upgrade') {
        // 文档升版保存
        res = await documentManagementService.setVersion(params)
      } else {
        res = await documentManagementService.saveDynamicTableData(params)
      }
      this.saveLoading = false
      if (res && res.code === 0) {
        this.$message.success('保存成功！')

        if (
          this.handoverFormProps.type === 'add' &&
          this.handoverFormProps.pageName === 'document'
        ) {
          // 关联文档新增成功后不关闭弹框，继续编辑
          this.title = '编辑'
          this.isEdit = true
          const isExistTab = this.tabsList.some((item) => {
            return item.label === '4'
          })
          if (!isExistTab) {
            this.tabsList.push({ name: '关联关系', label: '5' }, { name: '关联文件', label: '4' })
          }
          Object.assign(this.attributeTableProps, {
            type: 'edit',
            classId: this.baseForm.classId,
            tableDetailData: {
              ...res.data,
              folder_id: this.baseForm.folderId,
              class_id: this.baseForm.classId,
            },
            rowData: {
              id: res.data.id,
            },
          })
          this.getDynamicTableDataDetail(res.data.id)
          if (this.baseForm.folderId) {
            this.getPathName()
          }
          if (!this.handoverFormProps.isDataDetail) {
            this.classSelectChange(this.baseForm.classId)
          }
        } else if (this.handoverFormProps.type === 'upgrade') {
          // 升版保存成功，不关闭弹框
          this.isBeforeUpgrade = false
        } else {
          // 关闭弹框
          this.closeDialog()
        }
      }
    },
    // 获取详情数据
    async getDynamicTableDataDetail(id) {
      if (!this.attributeTableProps.classId) return
      const params = {
        classId: this.attributeTableProps.classId,
        dataId: id || this.handoverFormProps.rowData.id,
      }
      const res = await documentManagementService.getDynamicTableData(params)
      if (res && res.code === 0) {
        this.attributeTableProps.tableDetailData = res.data
      }
    },
    // 递归全部展开函数
    getAllOpen(val) {
      if (val.length) {
        _.forEach(val, (item) => {
          this.expandList.push(item.parentId)
          if (item.children && item.children.length) {
            this.getAllOpen(item.children)
          }
        })
      }
    },
    // 将树形数据拍平为一维数组
    flattenTreeData(treeData) {
      const result = []
      const flatten = (data) => {
        data.forEach((item) => {
          // 创建一个新对象，不包含children属性
          const { children, ...rest } = item
          result.push(rest)
          // 递归处理子节点
          if (item.children && item.children.length) {
            flatten(item.children)
          }
        })
      }
      flatten(treeData)
      return result
    },
    classNodeClick(node) {
      // 只允许选择叶子节点
      if (!node.isLeaf) {
        // 点击父节点时，不更新 currentClassNodeKey，保持之前的选中状态
        return
      }
      this.baseForm.classId = node.id
      this.defaultExpandedClassKey = [node.id]
      this.currentClassNodeKey = node.id
      this.baseForm.className = node.name
      this.classSelectChange(node.id, 'change', node)
    },
    // 控制当前选中节点，只允许叶子节点成为当前选中节点
    currentChange(currentNode) {
      if (currentNode && !currentNode.isLeaf) {
        // 如果点击的是非叶子节点，恢复之前的选中状态
        this.$nextTick(() => {
          this.$refs.classTree.setCurrentKey(this.currentClassNodeKey)
        })
      }
    },
    editNodeClick(node) {
      this.baseForm.folderId = node.id
      this.baseForm.pathName = node.path
      this.defaultExpandedKey = [this.baseForm.folderId]
      this.currentNodeKey = this.baseForm.folderId
      this.$refs.editSelectTree.blur()
    },
    // 加载目录树数据
    async loadNode(isRoot, nodeId) {
      const res = await documentManagementService.getDocumentTree({
        standardId: this.handoverFormProps.standardId,
        filter: this.treeKeyWord,
        isRoot, // 是否查询根节点，true：查询根节点，false：查询子节点
        nodeId, // 节点id
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 懒加载子节点
    async lazyNode(node, resolve) {
      let res = []
      if (node.data.id) {
        res = await this.loadNode(false, node.data.id)
      }
      resolve(res)
    },
    // 文档路径清空
    clearHandle(type) {
      if (type === 'add') {
        this.form.PathName = ''
        this.form.FolderId = ''
      } else if (type === 'edit') {
        this.detailsData.folderId = ''
        this.detailsData.pathName = ''
      } else if (type === 'upload') {
        this.uploadForm.PathName = ''
        this.uploadForm.PathId = ''
      } else {
        this.transferForm.destinationFolderName = ''
        this.transferForm.destinationFolderId = ''
      }
    },
    getPrimaryData(val) {
      this.primaryValue = val.value
    },
    // 扩展表格值
    extendTableValue(dataList) {
      // 扩展属性由单选变多选，同时渲染多个扩展属性tab
      dataList.forEach((item, index) => {
        item.extendTableProps = {
          attributeData: item.extendClassCode,
          attributeId: item.classAttributeId,
          data: this.primaryValue,
        }
        item.extendTableProps.attributeData = item?.extendClassCode
        item.extendTableProps.attributeId = item?.classAttributeId
        item.label = 10 + index
        const isExistTab = this.tabsList.find((val) => {
          return val.label === 10 + index
        })
        if (!isExistTab && this.attributeTableProps.type !== 'upgrade') {
          this.tabsList.push({
            name: item.extendClassName,
            label: 10 + index,
          })
        }
      })
      this.extendDataList = dataList
      // this.attributeTableProps.extendClassId = val?.extendClassId
      // this.extendTableProps.attributeData = val?.extendClassCode
      // this.extendTableProps.attributeId = val?.classAttributeId
      // const isExistTab = this.tabsList.find((item) => {
      //   return item.label === '6'
      // })
      // if (!isExistTab && !this.isEdit && this.attributeTableProps.type !== 'upgrade') {
      //   this.tabsList.push({
      //     name: val.extendClassName,
      //     label: '6',
      //   })
      // }
    },
  },
}
</script>

<style lang="scss" scoped>

.demo-form-inline .el-form-item__label {
  text-align: left !important;
}
/deep/.el-radio-button__inner {
  border-width: 2px !important;
  border-color: transparent !important;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: none;
  color: #000;
  border-bottom: 2px solid #0082ff !important;
  border-radius: 0 !important;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner,
.el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none !important;
}

</style>
<style lang="scss">

.handover-form-dialog {
  min-width: 850px;
}

</style>
